import { createReducer } from '../../store.model';

import { columnValueViewTransformer } from './column-value-view.transformer';
import {
    ActionType,
    CreateRow,
    CreateRowResult,
    DeleteRow,
    DeleteRowResult,
    ReloadResult,
    ReloadRows,
    ReloadRowsResult,
} from './table-editor.action';
import { TranslationKeyMap } from './table-editor.i18n';
import { defaultState, TableEditorState } from './table-editor.state';

const { builder, reducer } = createReducer<ActionType, TableEditorState>(
    defaultState(),
);

builder
    .add<{}>(ActionType.TABLE_EDITOR__RELOAD, () => {
        return defaultState();
    })
    .add<ReloadResult>(
        ActionType.TABLE_EDITOR__RELOAD_RESULT,
        (state, action) => {
            action.payload.tables.forEach((e) => {
                e.columns.sort((a, b) => a.columnOrder - b.columnOrder);
            });
            return {
                ...state,
                tables: action.payload.tables,
            };
        },
    );

builder
    .add<ReloadRows>(ActionType.TABLE_EDITOR__RELOAD_ROWS, (state, action) => {
        return {
            ...state,
            table: state.tables.find(
                (e) => e.tableId === action.payload.tableId,
            ),
            rows: null,
            rowViews: null,
            lastSaveSucceeded: null,
            message: null,
        };
    })
    .add<ReloadRowsResult>(
        ActionType.TABLE_EDITOR__RELOAD_ROWS_RESULT,
        (state, action) => {
            return {
                ...state,
                rows: action.payload.rows,
                rowViews: columnValueViewTransformer(action.payload.rows),
            };
        },
    );

builder
    .add<CreateRow>(ActionType.TABLE_EDITOR__CREATE_ROW, (state) => {
        return {
            ...state,
            pending: {
                ...state.pending,
                create: true,
            },
            lastSaveSucceeded: false,
            message: null,
        };
    })
    .add<CreateRowResult>(
        ActionType.TABLE_EDITOR__CREATE_ROW_RESULT,
        (state, action) => {
            let nextRows = state.rows;
            let nextRowViews = state.rowViews;
            if (action.payload.success) {
                nextRows = action.payload.rows;
                nextRowViews = columnValueViewTransformer(action.payload.rows);
            }
            return {
                ...state,
                pending: {
                    ...state.pending,
                    create: false,
                },
                rows: nextRows,
                rowViews: nextRowViews,
                lastSaveSucceeded: action.payload.success,
                message: action.payload.success
                    ? TranslationKeyMap._9750_ENTRY_CREATED
                    : TranslationKeyMap._9751_FAILED_TO_CREATE_ENTRY,
            };
        },
    );

builder
    .add<DeleteRow>(ActionType.TABLE_EDITOR__DELETE_ROW, (state, action) => {
        return {
            ...state,
            pending: {
                ...state.pending,
                delete: state.rows.indexOf(action.payload.row),
            },
            message: null,
        };
    })
    .add<DeleteRowResult>(
        ActionType.TABLE_EDITOR__DELETE_ROW_RESULT,
        (state, action) => {
            let nextRows = state.rows;
            let nextRowViews = state.rowViews;
            if (action.payload.success) {
                nextRows = [...state.rows];
                const index = nextRows.indexOf(action.payload.row);
                if (index !== -1) {
                    nextRows.splice(index, 1);
                }
                nextRowViews = columnValueViewTransformer(nextRows);
            }
            return {
                ...state,
                pending: {
                    ...state.pending,
                    delete: null,
                },
                rows: nextRows,
                rowViews: nextRowViews,
                message: action.payload.success
                    ? TranslationKeyMap._9752_ENTRY_DELETED
                    : TranslationKeyMap._9753_FAILED_TO_DELETE_ENTRY,
            };
        },
    );

builder.add<{}>(ActionType.TABLE_EDITOR__CLEAR_MESSAGE, (state) => {
    return {
        ...state,
        message: null,
    };
});

export const adminTableEditorReducer = reducer;
